import React from 'react'
import PropTypes from 'prop-types'
import { Box, Button, ButtonGroup } from '@resurs/midas-react'
import { getText } from '../../../internal/TextLabels'
import { getBorderType } from '../utils'
import { prettyPrintDate } from '../../../util/dateUtils'
import { getSanitizedHTML } from '../../../util/helpers'

const getHeading = ({ publicationStart, publicationEnd, visible }) => {
  let heading = prettyPrintDate(publicationStart)
  if (publicationEnd) {
    heading += ` - ${prettyPrintDate(publicationEnd)}`
  }
  heading += ' \u2022 ' // unicode bullet •
  heading += visible
    ? getText('news.list.published')
    : getText('news.list.notPublished')
  return heading
}

/* eslint-disable react/no-danger */
const AdminNewsArticle = ({ article, onEdit, onDelete }) => (
  <div style={{ marginBottom: '1rem' }}>
    <Box title={article.header} type={getBorderType(article.tags)}>
      <div
        style={{
          padding: '1.5rem 1.5rem 1rem 1.5rem ',
          color: '#777',
          fontSize: '1.2rem',
        }}
      >
        {getHeading(article)}
      </div>

      <div
        style={{ padding: '1.5rem 1.5rem 2.5rem 1.5rem', lineHeight: '2rem' }}
        dangerouslySetInnerHTML={{ __html: getSanitizedHTML(article.body) }}
      />

      <div style={{ display: 'flex', padding: '0.3rem' }}>
        <div style={{ marginLeft: 'auto', maxWidth: '20rem' }}>
          <ButtonGroup>
            <Button
              text={getText('default.edit')}
              size="small"
              type="link"
              onClick={onEdit}
            />
            <Button
              text={getText('default.delete')}
              size="small"
              type="link"
              onClick={onDelete}
            />
          </ButtonGroup>
        </div>
      </div>
    </Box>
  </div>
)

AdminNewsArticle.propTypes = {
  article: PropTypes.object.isRequired,
  onEdit: PropTypes.func,
  onDelete: PropTypes.func,
}

AdminNewsArticle.defaultProps = {
  onEdit: null,
  onDelete: null,
}

export default AdminNewsArticle
